<!--  -->
<template>
  <div :class="['ansResultBox', { inApp: $root.$data.isApp }]">
    <common-title titleName="压力测试" :bcColor="'#fff'" :zIndex="1000"> </common-title>
    <section class="drawReaultCenter">
      <img class="comeon" :src="imgsList[0]" alt="" />
      <div class="anscontent">
        <div class="headcount">
          <van-progress
            :percentage="(100 / questions.length) * (currIndex + 1)"
            stroke-width="10"
            color="linear-gradient(to right, #5DFA96, #2EC3FF)"
            ref="progress"
          />
          <h3>
            <span>{{ currIndex + 1 }}</span
            >/{{ questions.length }}
          </h3>
        </div>
        <div class="quesone">
          <h2>{{ currIndex + 1 }}、{{ questions[currIndex].title }}</h2>
          <div class="list">
            <div
              class="text-wrapper"
              v-for="(option, index) in questions[currIndex].options"
              :key="index"
              :class="{ selected: questions[currIndex].selected === option.value }"
              @click="selectOption(currIndex, option)"
            >
              <span class="option">{{ option.label }}</span>
              <span>{{ option.text }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="bottombox" v-if="currIndex > 0">
      <div class="lastques" v-if="isClicklastquestion">
        <img @click="prebtnBtn" :src="imgsList[2]" alt="Previous Button" />
        <img @click="checkBtn" :src="imgsList[3]" alt="Check Button" />
      </div>
      <div v-else>
        <img class="prebtn" @click="prebtnBtn" :src="imgsList[1]" alt="Previous Button" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ShareDraw from './shareDraw.vue';
import { postPressureTestApi } from '@/api/archives/index';

export default {
  components: {
    ShareDraw,
  },
  data() {
    return {
      isClicklastquestion: false,
      clickLock: false,
      currIndex: 0,
      questions: [
        {
          title: '最近一周，你每天平均的睡眠时间是？',
          options: [
            { label: 'A.', text: '小于 6 小时', value: 'A' },
            { label: 'B.', text: '6 - 8 小时', value: 'B' },
            { label: 'C.', text: '8 - 10 小时', value: 'C' },
            { label: 'D.', text: '大于 10 小时', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '在备考过程中，你是否经常感到焦虑？',
          options: [
            { label: 'A.', text: '几乎每天', value: 'A' },
            { label: 'B.', text: '一周几次', value: 'B' },
            { label: 'C.', text: '偶尔', value: 'C' },
            { label: 'D.', text: '很少或从不', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '当面对考研的巨大压力时，你的应对方式通常是：',
          options: [
            { label: 'A.', text: '逃避，无法集中精力学习', value: 'A' },
            { label: 'B.', text: '短暂焦虑后能继续投入学习', value: 'B' },
            { label: 'C.', text: '积极寻找解决办法，心态稳定', value: 'C' },
            { label: 'D.', text: '没有感觉，压力对自己没影响', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '对于考研的最终结果，你的想法是：',
          options: [
            { label: 'A.', text: '非常担心失败，觉得未来一片黑暗', value: 'A' },
            { label: 'B.', text: '有些担心，但相信努力会有好结果', value: 'B' },
            { label: 'C.', text: '顺其自然，尽力而为', value: 'C' },
            { label: 'D.', text: '完全不在乎结果，只享受过程', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '最近一个月，你是否经常出现情绪低落、沮丧的情况？',
          options: [
            { label: 'A.', text: '经常', value: 'A' },
            { label: 'B.', text: '有时', value: 'B' },
            { label: 'C.', text: '偶尔', value: 'C' },
            { label: 'D.', text: '很少或从未', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '在学习过程中，如果遇到难题长时间无法解决，你的反应是：',
          options: [
            { label: 'A.', text: '极度烦躁，想要放弃', value: 'A' },
            { label: 'B.', text: '会感到挫败，但会坚持尝试', value: 'B' },
            { label: 'C.', text: '冷静思考，尝试其他方法', value: 'C' },
            { label: 'D.', text: '觉得是正常现象，不影响心情', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '看到周围同学的复习进度比自己快，你会：',
          options: [
            { label: 'A.', text: '非常慌张，乱了自己的节奏', value: 'A' },
            { label: 'B.', text: '有点紧张，加快自己的进度', value: 'B' },
            { label: 'C.', text: '不受影响，按照自己的计划进行', value: 'C' },
            { label: 'D.', text: '认为进度不代表一切，注重知识掌握', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '对于每天的学习任务，你完成的情况是：',
          options: [
            { label: 'A.', text: '总是完不成，感到很焦虑', value: 'A' },
            { label: 'B.', text: '大部分能完成，偶尔有困难', value: 'B' },
            { label: 'C.', text: '基本都能按时完成', value: 'C' },
            { label: 'D.', text: '不仅能完成，还有余力做更多', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '当家人或朋友不理解你的考研选择时，你的感受是：',
          options: [
            { label: 'A.', text: '非常生气和委屈', value: 'A' },
            { label: 'B.', text: '有点失落，但能理解他们', value: 'B' },
            { label: 'C.', text: '试图解释，让他们理解', value: 'C' },
            { label: 'D.', text: '完全不在乎他们的看法', value: 'D' },
          ],
          selected: null,
        },
        {
          title: '想象一下考研结束后的情景，你的心情是：',
          options: [
            { label: 'A.', text: '充满恐惧，不知道结果如何', value: 'A' },
            { label: 'B.', text: '有些期待，又有些担心', value: 'B' },
            { label: 'C.', text: '充满信心，相信自己能成功', value: 'C' },
            { label: 'D.', text: '觉得无所谓，不在乎结果', value: 'D' },
          ],
          selected: null,
        },
      ],
      imgsList: [
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/comeon.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/prebtn.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/prebtnmin.png`,
        `${this.$global.OSS_IMAGE_PREFIX}/ark-student-wap/stresstest/resultmin.png`,
      ],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  watch: {},
  methods: {
    selectOption(index, option) {
      if (this.clickLock) return; // 如果点击锁定，直接返回
      this.clickLock = true; // 锁定进一步的点击
      if (index >= 0 && index < this.questions.length) {
        const question = this.questions[index];
        if (question) {
          question.selected = option.value;
          if (this.currIndex === this.questions.length - 1) {
            this.isClicklastquestion = true;
          } else if (
            this.currIndex === this.questions.length - 2 &&
            this.questions[this.questions.length - 1].selected
          ) {
            this.isClicklastquestion = true;
          }
          if (index < this.questions.length - 1) {
            setTimeout(() => {
              this.currIndex++;
              this.clickLock = false; // 在延时操作完成后解锁点击
            }, 600);
          }
          if (index == this.questions.length - 1) {
            this.clickLock = false;
          }
        }
      }
    },
    prebtnBtn() {
      this.currIndex--;
      this.isClicklastquestion = false;
      this.clickLock = false;
    },
    async checkBtn() {
      let drawNum = 1;
      let score = this.calculateTotalScore();
      //10≤总分≤20：重度emo族  21≤总分≤30：焦虑伴随者 31≤总分≤40：天选考研人
      if (score >= 10 && score <= 20) {
        drawNum = 0;
      } else if (score >= 21 && score <= 30) {
        drawNum = 1;
      } else {
        drawNum = 2;
      }
      const res = await postPressureTestApi({ score });
      this.$router.push({
        path: '/result',
        query: {
          drawNum,
        },
      });
    },

    calculateTotalScore() {
      let score = 0;
      this.questions.forEach((question) => {
        switch (question.selected) {
          case 'A':
            score += 1;
            break;
          case 'B':
            score += 2;
            break;
          case 'C':
            score += 3;
            break;
          case 'D':
            score += 4;
            break;
          default:
            break;
        }
      });
      return score;
    },
  },
  created() {
    window.onresize = () => {
      this.$refs.progress.resize();
    };
  },
  mounted() {
    window['iqhApp2jsBridge.triggerSC'] = {};
    setTimeout(() => {
      // 获取登录状态
      window['iqhApp2jsBridge.triggerSC'].getLogin = this.getLogin;
    }, 100);
  },
};
</script>
<style lang="scss" scoped>
.ansResultBox {
  box-sizing: border-box;
  width: 100%;
  padding-top: 100px;
  background: linear-gradient(180deg, #c5fcb8 0%, #dafbc7 100%);
  height: 100vh;

  &.inApp {
    padding-top: 0;
  }

  .drawReaultCenter {
    position: relative;
    width: 100%;
    padding-bottom: 140px;
    text-align: center;

    .comeon {
      display: block;
      width: 100%;
      height: 144px;
      margin: 0 auto;
    }

    .anscontent {
      position: relative;
      width: 698px;
      height: 787px;
      background: linear-gradient(180deg, #ffffff 0%, #e4f9ff 100%);
      border-radius: 40px;
      border: 2px solid #000000;
      margin: 0 auto;
      padding: 50px 40px;

      .headcount {
        display: flex;
        justify-content: space-between;
        align-content: center;

        h3 {
          font-weight: 500;
          font-size: 32px;
          margin-top: -10px;

          span {
            color: #ff7a5b;
          }
        }
      }

      .quesone {
        h2 {
          font-weight: 500;
          font-size: 32px;
          color: #000000;
          margin-top: 40px;
          text-align: left;
          line-height: 40px;
        }

        .list {
          position: absolute;
          bottom: 60px;
          margin: 0 auto;

          .text-wrapper {
            position: relative;
            width: 616px;
            height: 94px;
            line-height: 94px;
            background: #ffffff;
            border-radius: 48px;
            font-weight: 500;
            font-size: 30px;
            color: #000000;
            border: 2px solid #000000;
            margin-top: 30px;

            .option {
              position: absolute;
              left: 0;
              left: 30px;
            }
          }

          .selected {
            background-color: #6edf93;

            span {
              color: #fff;
            }
          }
        }
      }
    }
  }

  .bottombox {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 100%;
    height: 130px;
    background: #ffffff;
    box-shadow: 0px -5px 8px 0px rgba(95, 172, 120, 0.09);
    border-radius: 40px 40px 0px 0px;

    .prebtn {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 50px;
      display: block;
      width: 628px;
      height: 152px;
      margin: 0 auto;
    }

    .lastques {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 50px;
      display: flex;
      justify-content: center;

      img {
        display: block;
        width: 300px;
        height: 152px;
        margin: 0 15px;
      }
    }
  }
}

::v-deep .van-progress__pivot {
  width: 20px;
  height: 28px;
  background-image: url('https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/stresstest/pen.png') !important;
  background-size: 100% 100% !important;
  font-size: 0;
  // transform:translate(30%, 50%);
}

::v-deep .van-progress {
  width: 7rem;
}
</style>
